import { UrlParams } from '@sso/common-types';

export const getIsCheckoutLite = (urlParams: UrlParams) => {
  const { app, iframe, enableCheckoutLite, deckExperience } = urlParams;
  return iframe === 'true' && (enableCheckoutLite === 'true' || app === 'cart' || deckExperience === 'express_cart');
};
